import {eksmoBP} from "Lib/bp/bp";
import {getCookie} from "Lib/cookies/cookies";
import {eventSender} from "Lib/event-sender/event-sender";
import {getW} from "Lib/w/w";
import "Vendor/owlcarousel/owl.carousel.min";

var classSliderOn = 'owl-carousel';
var classBannerSliderLink = 'js-link';

function AjaxFormThis(form_el){
    $('.btn,.btn-new',form_el).click(function(){
        var parent = this;
        while(!$(parent).hasClass('ajax_form'))parent = $(parent).parent();
        $('.responce',parent).html('<img src="/local/templates/v2016/img/preloader_black.gif">');
        var o = {};
        $('input',parent).each(function(){
            if(($(this).attr('type')=='checkbox' || $(this).attr('type')=='radio') && !$(this).prop('checked')){
                return;
            }
            var name = $(this).attr('name');
            o[name] = $(this).val();
        });
        $('textarea',parent).each(function(){
            var name = $(this).attr('name');
            o[name] = $(this).val();
        });
        var action = $('#action',parent).val();
        if(action.indexOf('?')>0)action =action+'&rnd='+Math.random();
        else action =action+'?rnd='+Math.random();
        $.post(action,o,function(data){
            if($(parent).hasClass('responce'))
                $(parent).html(data);
            else
                $('.responce',parent).html(data);

            // EKSMORU-107
            var dataFsbscrb = $(form_el).data('fsbscrb');
            if(typeof dataFsbscrb === 'string' && dataFsbscrb.length && data.indexOf('green') !== -1)
                eventSender.customDL({'event': dataFsbscrb});

        });
        return false;
    })
}

function AjaxForm(){
    $('form.ajax_form').each(function(){
        AjaxFormThis(this);

    })
}

function InitSwitch(){
    $('.switches').each(function(){
        var mswitch = this;
        $('.switch',this).each(function(){
            $(this).click(function(){
                $('.switch',mswitch).each(function(){
                    $('#'+$(this).attr('rel')).css('display','none');
                    $(this).removeClass('selected');
                });
                $('#'+$(this).attr('rel')).stop().fadeIn();
                $(this).addClass('selected');
            })
        })
    });
}

function ewnd(a){
    var href = $(a).attr('href');
    if(typeof href !== 'undefined' && href != ''){
        var wwin = getW();
        if(wwin>560)wwin=560;
        var m_left = (screen.availWidth/2)-(wwin/2);
        var myWindow = window.open(href, "MsgWindow", "width="+wwin+", height=400, left="+m_left+", top=50");
        if(!myWindow)return true;
        return false;
    }
}

function fbShareV2(siteUrl, picture, title, caption, descr, winWidth,  winHeight) {


    var winTop = (screen.height / 2) - (winHeight / 2);
    var winLeft = (screen.width / 2) - (winWidth / 2);

    window.open('https://www.facebook.com/sharer.php?s=100&u=' + encodeURIComponent(siteUrl) + '&picture=' + picture + '&title=' + title + '&caption=' + encodeURIComponent(caption) +'&description=' + descr, 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
}

window.GetSNHtml = function(url,title,txt,img,mob,keep_get_params){
    if(!keep_get_params){
        var urlArr = url.split('?');
        url = urlArr[0];
    }
    var fbURL = url;
    var vkURL = url;
    var twURL = url;
    var okURL = url;
    var delimiter = '&';
    if(url.indexOf('?') == -1)
        delimiter = '?';
    if(typeof fbUTMs !== 'undefined')
        fbURL += delimiter + fbUTMs;
    if(typeof vkUTMs !== 'undefined')
        vkURL += delimiter + vkUTMs;
    if(typeof twUTMs !== 'undefined')
        twURL += delimiter + twUTMs;
    if(typeof okUTMs !== 'undefined')
        okURL += delimiter + okUTMs;
    var frm = '';
    var a='';
    //a += '<a class="fb" onclick="return ewnd(this)" target="_blank" href="http://www.facebook.com/sharer.php?s=100&p[title]='+encodeURIComponent(title) + '&p[summary]=' + encodeURIComponent(txt) + '&p[url]=' + encodeURIComponent(url) + '&p[images][0]=' + encodeURIComponent(img)+ '"><i class="ei-facebook"></i></a>';
    //a += '<a class="fb" onclick="return FBShare(this)"  target="_blank" data-description="' + encodeURIComponent(txt) + '" data-title="' + encodeURIComponent(title) + '" data-url="' + encodeURIComponent(fbURL) + '" data-image="' + encodeURIComponent(img) + '" href="https://www.facebook.com/dialog/feed?display=popup&app_id=591459424366863&link=' + encodeURIComponent(fbURL) + '&picture=' + encodeURIComponent(img) + '&name=' + encodeURIComponent(title) + '&description=' + encodeURIComponent(txt) + '&caption=' + encodeURIComponent(title) + '&redirect_uri=&ref=click_share_sb"><i class="ei-facebook"></i></a>';
    a += '<a class="vk" onclick="return ewnd(this)"  target="_blank" href="http://vk.com/share.php?url=' + encodeURIComponent(vkURL) + '&title=' + encodeURIComponent(title) + '&description=' + encodeURIComponent(txt) + '&image=' + encodeURIComponent(img) + '"><i class="ei-vk"></i></a>';
    a += '<a class="tw" onclick="return ewnd(this)"  target="_blank" href="https://twitter.com/intent/tweet?text=' + encodeURIComponent(title) + '&url=' + encodeURIComponent(twURL) + '"><i class="ei-twitter"></i></a>';
    a += '<a class="ok" onclick="return ewnd(this)"  target="_blank" href="https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&amp;st.shareUrl=' + encodeURIComponent(okURL) + '"><i class="ei-odnoklassniki"></i></a>';
    // a += '<a class="mm" onclick="return ewnd(this)"  target="_blank" href="https://connect.mail.ru/share?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title) + '&description=' + encodeURIComponent(txt) + '&image_url=' + encodeURIComponent(img) + '"><i class="ei-email"></i></a>';



    if(mob){
        frm += '<div class="visible-xs"><div class="e-sn-mob">';
        frm+=a;
        frm += '</div></div>';
        frm += '<div class="e-sn-mob-toggle visible-xs"></div>';
    }

    frm += '<div class="e-sn ';
    if(mob)frm +='hidden-xs';
    frm += '">';
    frm+=a;
    frm += '</div>';
    return frm;
}

$.fn.eTextErrorReports = function(prop){
    var err_reports_container = this;
    err_reports_container.flg = true;
    err_reports_container.getSelText = function(){
        var sel_obj = window.getSelection();
        var sel_text = sel_obj.toString();
        return sel_text;
    };

    err_reports_container.close = function(){
        $('#popup_err_report_text').fadeOut();
    };
    err_reports_container.sendReport = function(){
        var o = {};
        o.text = err_reports_container.getSelText();
        o.url = document.location.href;
        $('#popup_err_report_text .report_res').html('<img src="/local/templates/v2016/img/preloader_black.gif">');
        $.post('/ajax/err_report/',o,function(data){
            if(data=='OK') {
                $('#popup_err_report_text .report_res').html('<span class="ok">Сообщение отправлено!</span>');
                setTimeout(err_reports_container.close,1500);
            }
        })
    };
    $(err_reports_container).on('mousedown',function(e) {
        var txt = err_reports_container.getSelText();
        if(txt.length>0)err_reports_container.flg=false;
        else err_reports_container.flg=true;
    });
    $(err_reports_container).on('mouseup',function(e){
        var deny = false;
        var elem = e.target||e.srcElement;
        while(elem.tagName.toLowerCase()!='body'){
            console.log(elem.tagName+$(elem).attr('class'));
            if($(elem).hasClass('yn_test'))deny=true;
            elem = $(elem).parent().get(0);
        }
        if(deny)return true;
        var l = e.pageX;
        l-=240;
        if(l<0)l=0;
        var t = e.pageY - 20;
        if(t<0)t=0;
        var txt = err_reports_container.getSelText();
        if(txt!='' && err_reports_container.flg) {
            var frm = '<div id="popup_err_report_text" class="popup_err_report" style="display:none; top:' + t + 'px; left:' + l + 'px;">';
            frm += '<div class="report_res">';
            frm += '<a class="report" href="javascript:void(0)">Сообщить об опечатке</a>';
            frm += '</div>';
            if (txt.length > 200)
                txt = txt.substr(0, 200) + "...";
            var url = document.location.href;
            var title = $("meta[property='og:title']").attr('content');
            if (title == '')title = $('title').innerHTML();
            if (title == '')title = $('h1').innerHTML();
            if (title == '')title = $('.h1').innerHTML();
            var img = $("meta[property='og:image']").attr('content');
            if (!!!img)img = $('img', err_reports_container).attr('src');
            if (!!!img)img = '';
            if (img != '' && img.indexOf('http') < 0)img = "https://eksmo.ru" + img;
            frm+=GetSNHtml(url,title,txt,img,false);
            frm += '</div>';
            $('#popup_err_report_text').remove();
            $('body').append(frm);
            $('#popup_err_report_text').fadeIn();
            $('#popup_err_report_text .report').click(err_reports_container.sendReport);
            $('#popup_err_report_text').mouseleave(err_reports_container.close);
        }
    })
};

$.fn.eImgSNShare = function(prop) {
    var img_sn_share_container = this;
    img_sn_share_container.aImg = Array();

    img_sn_share_container.title = $("meta[property='og:title']").attr('content');
    if (img_sn_share_container.title == '')img_sn_share_container.title = $('title').innerHTML();
    if (img_sn_share_container.title == '')img_sn_share_container.title = $('h1').innerHTML();
    if (img_sn_share_container.title == '')img_sn_share_container.title = $('.h1').innerHTML();
    img_sn_share_container.description = $("meta[property='og:description']").attr('content');
    $('img[width="100%"],.img img',img_sn_share_container).each(function(index,image){
        var src = $(this).attr('src');
        img_sn_share_container.aImg[index] = new Image();
        img_sn_share_container.aImg[index].src =src;
        img_sn_share_container.aImg[index].onload =function(){img_sn_share_container.createSn(index)};
    });
    img_sn_share_container.createSn = function(index){
        var $img_tag = $($('img[width="100%"],.img img',img_sn_share_container).get(index));
        var p = $($img_tag.parent()).get(0);
        if(p.tagName=='a' || p.tagName=='A')$img_tag = $(p);
        $img_tag.wrap('<div id="img_sn_share'+index+'" class="img_sn_share"></div>');
        var $cnt = $('#img_sn_share'+index);
        var url = document.location.href;
        var src = new String($('img',$cnt).attr('src'));
        src = src.replace('https://eksmo.ru','');
        src = src.replace('https://','');
        src = src.replace('http://','');
        src = src.replace('//eksmo.ru','');
        src = 'https://eksmo.ru'+src;
        var sn_html = GetSNHtml(url,img_sn_share_container.title,img_sn_share_container.description,src,true);
        $cnt.append(sn_html);
        $('.e-sn-mob-toggle',$cnt).click(function(){
            $('.e-sn-mob',$(this).parent()).fadeIn(200);
            $(this).remove();
        });
        $($cnt).mouseenter(function(){
            $('.e-sn',this).fadeIn();
        });
        $($cnt).mouseleave(function(){
            $('.e-sn',this).fadeOut();
        })
    }
};

$('.e-sn-fixed').removeClass('visible-xs').removeClass('visible-sm').addClass('hidden');
$(window).scroll(function(){
    if($(window).scrollTop() > $(window).height())
        $('.e-sn-fixed').addClass('visible-xs').addClass('visible-sm').removeClass('hidden');
    else
        $('.e-sn-fixed').removeClass('visible-xs').removeClass('visible-sm').addClass('hidden');
});

$(document).ready(function() {
    if($('.text_err_report').length)
        $('.text_err_report').eTextErrorReports();

    if($('.sn_img_share').length)
        $('.sn_img_share').eImgSNShare();

    $('a[data-target="#modal_window"]').on('click',
        function(e) {
            $('#popup_modal_cnt').html('<img src="/local/templates/v2016/img/preloader_black.gif">');
            e.preventDefault();
            $('#popup_modal_cnt').load($(this).attr('href'));
        }
    );

    $(document).click(function(event) {
        if ($(event.target).closest("#shops_popup").length || $(event.target).closest("#shops_popup_btn").length){
            $('#top_login_popup').addClass('hidden');
            return;
        }

        if ($(event.target).closest("#top_login_popup").length || $(event.target).closest("#top_login_popup_btn").length){
            $('#shops_popup').addClass('hidden');
            return;
        }



        $('#shops_popup').addClass('hidden');
        $('#top_login_popup').addClass('hidden');
        event.stopPropagation();
    });


    AjaxForm();
    InitSwitch();


    if($('.js-bg-video').length){
        var ytScript = document.createElement('script');
        ytScript.type = 'text/javascript';
        ytScript.src = '//www.youtube.com/player_api';
        document.getElementsByTagName('head')[0].appendChild(ytScript);
    }
    $('.js-bg-video').on('click',function(){
        var videoID = $(this).data('video');
        var start = $(this).data('start');
        if(videoID.length){
            var play = new YT.Player('bky_'+videoID,{videoId:videoID,playerVars:{'autoplay':0,'showinfo':0,'rel':0,'start':start},height:'295',width:'100%',events:{'onReady':function(){play.playVideo()}}});
        }
    });
});

$(document).ready(function(){
    { // Spoiler banner digest on novinki page
        var elContent = $('#digest_banner-content');
        var elLinkShow = $('#digest_banner-link-show');
        var elLinkHide = $('#digest_banner-link-hide');

        elLinkShow.on('click', function(){
            var elH = elContent.children().first();
            if(elH.length)
                elContent.height(elH.height());
            setTimeout(function(){
                elLinkShow.hide();
                elLinkHide.show();
            }, 200);
        });

        elLinkHide.on('click', function(){
            elContent.height(0);
            setTimeout(function(){
                elLinkHide.hide();
                elLinkShow.show();
            }, 200);
        });
    }

    { // слайдер в разделах каталога
        var elsForSlider = $('.js-catalog-slider');
        var classSliderOn = 'owl-carousel';

        elsForSlider.each(function(){
            var navContainer = $(this).parents('.e-book-list').find('.js-catalog-slider-nav');
            $(this).trigger('destroy.owl.carousel')
            .removeClass(classSliderOn)
            .addClass(classSliderOn)
            .owlCarousel({
                nav: true,
                dots: false,
                navContainer: navContainer,
                margin: 15,
                navText: ['<svg viewBox="0 0 60 60" class="svg-circle"><path d="M30 0C13.458 0 0 13.458 0 30s13.458 30 30 30 30-13.458 30-30S46.542 0 30 0zm0 58C14.561 58 2 45.439 2 30S14.561 2 30 2s28 12.561 28 28-12.561 28-28 28z"/></svg>', '<svg viewBox="0 0 60 60" class="svg-circle"><path d="M30 0C13.458 0 0 13.458 0 30s13.458 30 30 30 30-13.458 30-30S46.542 0 30 0zm0 58C14.561 58 2 45.439 2 30S14.561 2 30 2s28 12.561 28 28-12.561 28-28 28z"/></svg>'],
                responsive: {
                    0: {items:1, slideBy:1, stagePadding:55, autoWidth:true},
                    340: {items:1, slideBy:1, stagePadding:65, autoWidth:true},
                    380: {items:1, slideBy:1, stagePadding:80, autoWidth:true},
                    420: {items:1, slideBy:1, stagePadding:90, autoWidth:true},
                    450: {items:1, slideBy:1, stagePadding:100, autoWidth:true},
                    500: {items:1, slideBy:1, stagePadding:120, autoWidth:true},
                    550: {items:1, slideBy:1, stagePadding:140, autoWidth:true, margin:30},
                    600: {items:3, slideBy:3, margin:30},
                    980: {items:4, slideBy:4, margin:30},
                    1155: {items:4, slideBy:4, margin:40},
                    1280: {items:4, slideBy:4, margin:40}
                }
            });
        });
    }

    var $colTitleOnBookPage = $('#book-page-col-title');
    var $colCover3dOnBookPage = $('#book-page-col-cover3d');
    if(getW() > eksmoBP.xsMax && $colTitleOnBookPage.length && $colCover3dOnBookPage.length && $colTitleOnBookPage.height() > $colCover3dOnBookPage.height())
        $colCover3dOnBookPage.height($colTitleOnBookPage.height());


    { // Галерея
        var $elsForSlider = $('.js-e-news-gallery');
        if($elsForSlider.length){
            var classSliderOn = 'owl-carousel';
            var selectorTextBlock = '.js-text-block';
            var selectorTextBlockItems = '.js-text-block-item';

            function setHeightTextBlock($block, numSlide){
                var numSlide = parseInt(numSlide) || 0;
                $block.each(function(){
                    var $textCont = $(this).parent().find(selectorTextBlock);
                    var $textItems = $textCont.find(selectorTextBlockItems);
                    var $currentTextBlock = $textItems.eq(numSlide);
                    $textCont.height($currentTextBlock.height());
                    $textItems.removeClass('active');
                    $currentTextBlock.addClass('active');
                });
            }

            function prewSlided(e){
                setHeightTextBlock($(e.currentTarget), e.item.index);
            }

            $elsForSlider.each(function(){
                $(this).trigger('destroy.owl.carousel')
                .removeClass(classSliderOn)
                .addClass(classSliderOn)
                .owlCarousel({
                    nav: true,
                    dots: false,
                    margin: 40,
                    navText: ['<div class="line"></div>', '<div class="line"></div>'],
                    animateIn: 'fadeIn',
                    animateOut: 'fadeOut',
                    responsive: {
                        0: {items:1, slideBy:1, stagePadding:30, margin:13, animateIn:false, animateOut:false, nav:false},
                        770: {items:1, slideBy:1}
                    }
                })
                .on('translate.owl.carousel', prewSlided);
            });

            setHeightTextBlock($elsForSlider);
            var w = getW();
            $(window).on('resize', function(){
                var newW = getW();
                if(newW != w){
                    w = newW;
                    $elsForSlider.trigger('to.owl.carousel', 0);
                    setHeightTextBlock($elsForSlider);
                }
            });
        }
    }
});

// Viktor - Mybook popup
function showPopupMybook(){
    return;
    //if($('.debug_showPopupMybook').length<=0)return;
    if(getCookie('PREMIUM_POPUP_MYBOOK_SHOWED') != 'Y'){
        setTimeout(function(){
            var w = getW();
            if(w > eksmoBP.xsMax){
                $(document).ready(function(){
                    $.fancybox({
                        fitToView: true,
                        autoSize: true,
                        openEffect: 'none',
                        closeEffect: 'none',
                        scrolling: 'no',
                        minWidth: 480,
                        tpl: {
                            wrap: '<div class="fancybox-wrap fancybox-mybook-popup" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>'
                        },
                        type: 'ajax',
                        href: '/ajax/mybook-popup/form/'
                    });

                    var date = new Date(new Date().getTime() + 60*1000*60*24*365*3);  // на 3 года
                    document.cookie = 'PREMIUM_POPUP_MYBOOK_SHOWED=Y; path=/; domain=' + location.hostname + '; expires=' + date.toUTCString();
                });
            }
        }, 7500);
        showPopupMybook = function(){};
    }
}

$(document).ready(function () {
    window.addEventListener("message", function (e) {
        if (e.data === 'ReloadPage') {
            alert('ReloadPage');
        }
    }, false);
});













// Viktor - selectbox
export function EksmoSelectbox(selector, functionAfterSelect){
    if(selector.length){
        var elsSelectFilter = $(selector);

        if(elsSelectFilter.length){
            var cShow = 'js-show';
            var cItem = 'js-item';
            var cActive = 'js-active';
            var sCont = '.cont';
            var cItemTemp = 'js-item-temp';

            elsSelectFilter.each(function(){
                var thiss = $(this);

                if(!thiss.find('.' + cItem + '.' + cActive).length)
                    thiss.find(sCont).first().prepend('<div class="item js-item ' + cItemTemp + ' js-active">&nbsp;</div>');

                thiss.on('click', '.' + cItem, function(e){
                    if($(this).hasClass(cActive)){
                        e.preventDefault();

                        if(thiss.hasClass(cShow)){
                            thiss.removeClass(cShow);
                        }else{
                            elsSelectFilter.removeClass(cShow);
                            thiss.addClass(cShow);
                        }
                    }else{
                        var elsItem = thiss.find('.' + cItem);

                        elsSelectFilter.filter('.' + cShow).removeClass(cShow);
                        thiss.removeClass(cShow);
                        elsItem.removeClass(cActive);
                        $(this).addClass(cActive);

                        if(typeof functionAfterSelect == 'function')
                            functionAfterSelect(thiss.attr('id'), $(this).data('value'));

                        thiss.find('.' + cItemTemp).remove();
                    }

                    elsSelectFilter.find(sCont).scrollTop(0);
                });
            });

            $(document).click(function(e){
                if($(e.target).closest(selector).length)
                    return;

                elsSelectFilter.removeClass(cShow);
                elsSelectFilter.find(sCont).scrollTop(0);

                e.stopPropagation();
            });

            $(document).keydown(function(e){
                if(e.which == 27){
                    elsSelectFilter.removeClass(cShow);
                    elsSelectFilter.find(sCont).scrollTop(0);
                }
            });
        }
    }
}

// Viktor - radiobox
export function EksmoRadiobox(selector, functionAfterCheck){
    if(selector.length){
        var elLabel = $(selector);

        if(elLabel.length){
            var labelcActive = 'js-active';

            $(elLabel).on('change', 'input[type=radio]', function(){
                if($(this).is(':checked')){
                    elLabel.find('input[type=radio][name=' + $(this).attr('name') + ']').each(function(){
                        $(this).parents(selector).removeClass(labelcActive);
                    });

                    $(this).parents(selector).addClass(labelcActive);
                }

                if(typeof functionAfterCheck == 'function')
                    functionAfterCheck($($(this).parent()).attr('id'), $(this).parents(selector).hasClass(labelcActive));
            });

            $(elLabel).find('input[type=radio]').each(function(){
                if($(this).is(':checked'))
                    $(this).parents(selector).addClass(labelcActive);
            });
        }
    }
}

// Viktor - switchbox
export function EksmoSwitchbox(selector, functionAfterCheck){
    if(selector.length){
        var elLabel = $(selector);

        if(elLabel.length){
            var labelcActive = 'js-active';

            $(elLabel).on('change', 'input[type=checkbox]', function(){
                if($(this).is(':checked'))
                    $(this).parents(selector).addClass(labelcActive);
                else
                    $(this).parents(selector).removeClass(labelcActive);

                if(typeof functionAfterCheck == 'function')
                    functionAfterCheck($($(this).parent()).attr('id'), $(this).parents(selector).hasClass(labelcActive));
            });

            $(elLabel).find('input[type=checkbox]').each(function(){
                if($(this).is(':checked'))
                    $(this).parents(selector).addClass(labelcActive);
            });
        }
    }
}